import React, { Fragment } from "react";
import Typography from '@mui/material/Typography';



export default function UserManual() {
  const iframeUrl='<iframe width="70%" height="800" src="https://docs.google.com/document/d/e/2PACX-1vQ0_5HlNod4f8DBfOrKUsyNBwRBFAGh3LvDMZK2K6PPYVQKgUmHXYvBCI2Uk-zVTMuiNYiVFkHKLoVh/pub?embedded=true"></iframe>';
  return (
    <Fragment>
      <Typography variant="h3" component="h2">
        User Manual
      </Typography>

      <Iframe iframe={iframeUrl}></Iframe>
      </Fragment>
  );
  function Iframe(props) {
    
    return (
      <div
        dangerouslySetInnerHTML={{ __html: props.iframe ? props.iframe : "" }}
      />
    );
  }

}